import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerIcon} from '../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../libs/shared/ui/src/components/banners/bannersContext';
import {BannerText} from '../../../../libs/shared/ui/src/components/banners/bannerText';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {
  LensesErrorBannerState,
  LensesErrorBannerTypesEnum,
} from '../../../store/panels/app/banners/bannersState';

interface LensesErrorBannerProps {
  banner: LensesErrorBannerState;
  onClose: () => void;
}

export const LensesErrorBanner: FC<LensesErrorBannerProps> = (props) => {
  const {banner, onClose} = props;
  const theme = useUserTheme();

  return (
    <Banner
      bannerType={BannerTypesEnum.INLINE}
      priority={BannerPrioritiesEnum.ERROR}
      color={theme.palette.red.shade40} // TODO-LENS: Get actual color
    >
      <BannerIcon iconName="crossCircleSmall" />
      <BannerText>{renderBannerContent(banner)}</BannerText>
      <BannerCloseAction onClick={onClose} />
    </Banner>
  );
};

// TODO-LENS: Get actual copies
function renderBannerContent(banner: LensesErrorBannerState) {
  if (banner.lensError) {
    return banner.lensError;
  }

  switch (banner.lensErrorType) {
    case LensesErrorBannerTypesEnum.LENS_CREATION_FAILED:
      return <Trans id="banner-lens-creation-failed">Failed to create saved view.</Trans>;
    case LensesErrorBannerTypesEnum.LENS_EDIT_FAILED:
      return <Trans id="banner-lens-edit-failed">Failed to edit saved view</Trans>;
    case LensesErrorBannerTypesEnum.LENS_DELETION_FAILED:
      return <Trans id="banner-lens-deletion-failed">Failed to delete saved view</Trans>;
    default:
      return null;
  }
}
